import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface CapacityManagementEstimatedVsActualHoursUsersPayload
  extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_USERS;
    id: string;
    attributes: {
      data: Array<{
        user_id: string;
        user_name: string;
        user_role: string;
        user_type: string;
        user_email: string;
        user_status: string;
        user_last_name: string;
        user_avatar_url: string | null;
        user_first_name: string;
        user_disabled_at: string | null;
        allocated_hours_in_range: number;
        actual_hours_in_range: number;
      }>;
    };
  };
}

export const parseCapacityManagementEstimatedVsActualHoursUsersPayload = (
  payload: BaseInsightPayload
): CapacityManagementEstimatedVsActualHoursUsersPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_USERS,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as unknown as {
    data: Array<{
      user_id: string;
      user_name: string;
      user_data: {
        role: string;
        type: string;
        email: string;
        status: string;
        user_id: string;
        last_name: string;
        avatar_url: string | null;
        first_name: string;
        disabled_at: string | null;
      };
      allocated_hours_in_range: number;
      actual_hours_in_range: number;
    }>;
  };

  // Flatten the user_data object into individual properties
  const flattenedData = typedAttributes.data.map((item) => ({
    user_id: item.user_id,
    user_name: item.user_name,
    user_role: item.user_data.role,
    user_type: item.user_data.type,
    user_email: item.user_data.email,
    user_status: item.user_data.status,
    user_last_name: item.user_data.last_name,
    user_avatar_url: item.user_data.avatar_url,
    user_first_name: item.user_data.first_name,
    user_disabled_at: item.user_data.disabled_at,
    allocated_hours_in_range: item.allocated_hours_in_range,
    actual_hours_in_range: item.actual_hours_in_range,
  }));

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_USERS,
      id: data.id,
      attributes: {
        data: flattenedData,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
